module.exports = __webpack_public_path__ + "img/background.18064a73.webp";